import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take, tap } from 'rxjs';
import { UserService } from '../services/user.service';

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const user = inject(UserService);

  return user.isAdmin$.pipe(
    take(1),
    tap(isAdmin => {
      if (!isAdmin) {
        router.navigate(['/']);
      }
    }),
    map(isAdmin => isAdmin)
  );
};
